import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './BuyButton';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-144" data-mp="juhlhrxg7i8h">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-sand bg-cream/95 px-4 py-3 backdrop-blur" data-id="element-145" data-mp="jtpnybkajafk">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4" data-id="element-146" data-mp="24aunnhbu0nnr">
            <p className="text-sm text-cocoa" data-id="element-147" data-mp="2491f1whnrtd4">
              <span className="hidden sm:inline" data-id="element-148" data-mp="3idxm29jhog8i">Organiza Tu Vida en 7 Días · </span>
              <span className="mr-1.5 line-through opacity-60" data-id="element-149" data-mp="3mh3rjeys23dx">$19</span>
              <strong className="font-semibold text-terracotta" data-id="element-150" data-mp="38gsx61y9e6o0">$9 USD</strong>
            </p>
            <a href={CHECKOUT_URL} className="group inline-flex items-center gap-2 bg-terracotta px-5 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-cream transition-colors hover:bg-cocoa focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2" data-id="element-151" data-mp="38j5q1a5k21fu">
              Comprar ahora
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-152" data-mp="3rf5i0kyj94zf" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}